import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import Lottie from 'lottie-react';
import Loader from '../../../assests/animation/Loader2.json';
import OverallReview from '../../../components/OverallReview/OverallReview';
import LikeIcon from '../../../assests/images/LikeIcon.png';
import LoveIcon from '../../../assests/images/LoveIcon.png'
import {
  AngryIcon,
  CareIcon,
  FacebookIcon,
  FacebookLogo,
  HappyIcon,
  Instagram,
  InstagramIconSmall,
  InstagramLogo,

  SadIcon,

  WowIcon,

  X_icon,
  YouTubeRedIcon,
} from '../../../Common/SvgIcon/CommonSvgIcons';

import GraphHOC from '../../../Common/GraphHOC/GraphHOC';
import TrendsInUserActivity from '../../../Common/TendsInUserActivity/TrendsInUser_activity';
import BarGraph from '../../../Common/BarGraph/BarGraph';
import RatingDonutChart from '../../../Common/RatingDonutChart/DonutChart';
import DonutChart from '../../../Common/SentimentCharts/SentimentCharts';
import FunnelGraph from '../../../Common/FunnelGraph/FunnelGraph';
import VerticalBarGraph from '../../../Common/BarGraph/VarticalBargraph';
import { format, parse } from 'date-fns';
import { useParsedEndDate, useParsedStartDate } from '../../../utils/ParseDate';
import DynamicCorrelationGraph from '../../../components/DynamicCorrelationGraph/DynamicCorrelationGraph';
import { useDispatch } from 'react-redux';
import SidePanel from '../../../components/SidePanel/SidePanel';
import { DetailedInsightsData } from '../../../store/redux/slices/topicSlice';
import {
  convertDateFormat,
  convertDateFormatString,
} from '../../../utils/ConvertDateFormat';

const Wrapper = styled.div`
  padding: 30px;
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;
const Container = styled.div`
  display: flex;
  gap: 30px;
  height: 380px;
`;

const GraphWrapper = styled.div`
  border-radius: 15px;
  border: 1px solid #d9d9d9;
  padding: 0px 10px;
  align-items: center;
  margin-top: 30px;

  &>p: first-child {
    ${'' /* color: #636363; */}
    font-family: Montserrat;
    font-size: 15px;
    font-weight: 500;
    margin: 20px 0px 0px 10px;
  }
`;

const ChildContainer = styled.div`
  flex: 1;
  height: 100%;
  border-radius: 15px;
  border: 1px solid #d9d9d9;

  display: flex;
  justify-content: ${(props) => (props.justify ? props.justify : 'center')};
  align-items: center;
  box-sizing: border-box;
`;

const ChildContainer1 = styled(ChildContainer)`
  width: 50%;
  height: max-content;
`;
const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 15px;
  border: 1px solid #d9d9d9;
  /* justify-content: center; */
  /* align-items: center; */
  box-sizing: border-box;
  padding: 5px;

  span {
    color: #636363;
    font-family: Montserrat;
    font-size: 15px;
    font-weight: 500;

    justify-content: space-between;
    align-items: center;
    margin: 10px 0px 0px 10px;
  }

  div {
    margin: 10px 0px 0px 0px;
  }
`;

const LoaderDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80vh;
    & > svg {
    
    width: 300px;
    height: 300px;
    }
}
`;
const OverviewTabFb = ({
  overview_tab,
  startDate = '',
  endDate = '',
  filteredStartDate,
  filteredEndDate,
  filterOption,
  filteredData,
  resetFlag,
  view,
  job_id,
  preview_uuid,
  channel,
  hideDropdown,
  formatValue = 'dd-yyyy-MM',
  handleTabClick,
  search_type = '',
}) => {
  const options = ['Bar Graph', 'Pie Chart', 'Donut Chart', 'Funnel Chart'];
  const engagementData = [
    {
      name: 'Likes',
      value:
        resetFlag === true && filteredData
          ? filteredData?.engagement?.likes
          : overview_tab?.engagement?.likes || 0,
      fill: '#6640B8',
    },
    {
      name: 'Comments',
      value:
        resetFlag === true && filteredData
          ? filteredData?.engagement?.comments
          : overview_tab?.engagement?.comments || 0,
      fill: '#5FE495',
    },
    {
      name: 'Shares',
      // value: 869,
      value:
        resetFlag === true && filteredData
          ? filteredData?.engagement?.shares
          : overview_tab?.engagement?.shares || 0,
      fill: '#6F62FE',
    },
    // {
    //     name:'Saved',
    //     value:resetFlag === true && filteredData ? filteredData?.engagement.saved : overview_tab?.engagement?.saved || 0,
    //     fill:'#AB71CE'
    // }
  ];

  const genderDemographicsData = [
    {
      name: 'Male',
      value:
        resetFlag === true && filteredData
          ? filteredData?.gender_demographics?.male_percentage
          : overview_tab?.gender_demographics?.male_percentage || 0,
      // fill: '#6640B8',
      fill: '#3D9FF8',
    },
    {
      name: 'Female',
      value:
        resetFlag === true && filteredData
          ? filteredData?.gender_demographics?.female_percentage
          : overview_tab?.gender_demographics?.female_percentage || 0,
      // fill: '#EAAABD',
      fill: '#FF9AB8',
    },
    {
      name: 'Unknown',
      value:
        resetFlag === true && filteredData
          ? filteredData?.gender_demographics?.unknown_percentage
          : overview_tab?.gender_demographics?.unknown_percentage || 0,
      // fill: '#E4E4E4',
      fill: 'rgba(218, 217, 219,  0.8)',
    },
  ];
  const reactionsData = [
    {
      name: 'Like',
      value:
        resetFlag === true && filteredData
          ? filteredData?.top_reactions?.like
          : overview_tab?.top_reactions?.like || 0,
      // fill: '#6640B8',
      fill: 'rgba(53, 60, 247, 1)',
    },
    {
      name: 'Love',
      value:
        resetFlag === true && filteredData
          ? filteredData?.top_reactions?.love
          : overview_tab?.top_reactions?.love || 0,
      // fill: '#EAAABD',
      fill: 'rgba(255, 155, 0, 1)',
    },
    {
      name: 'Care',
      value:
        resetFlag === true && filteredData
          ? filteredData?.top_reactions?.care
          : overview_tab?.top_reactions?.care || 0,
      // fill: '#E4E4E4',
      fill: 'rgba(164, 7, 238, 1)',
    },
    {
      name: 'Haha',
      value:
        resetFlag === true && filteredData
          ? filteredData?.top_reactions?.haha
          : overview_tab?.top_reactions?.haha || 0,
      // fill: '#E4E4E4',
      fill: 'rgba(218, 6, 184, 1)',
    },
    {
      name: 'Angry',
      value:
        resetFlag === true && filteredData
          ? filteredData?.top_reactions?.angry
          : overview_tab?.top_reactions?.angry || 0,
      // fill: '#E4E4E4',
      fill: 'rgba(243, 27, 27, 1)',
    },
    {
      name: 'Wow',
      value:
        resetFlag === true && filteredData
          ? filteredData?.top_reactions?.wow
          : overview_tab?.top_reactions?.wow || 0,
      // fill: '#E4E4E4',
      fill: 'rgba(3, 198, 82, 1)',
    },

    {
      name: 'Sad',
      value:
        resetFlag === true && filteredData
          ? filteredData?.top_reactions?.sad
          : overview_tab?.top_reactions?.sad || 0,
      // fill: '#E4E4E4',
      fill: 'rgba(218, 217, 219, 1)',
    },
  ];
  const engagementGraphData = [
    {
      name: 'Reactions',
      value:
        resetFlag === true && filteredData
          ? filteredData?.engagement?.likes
          : overview_tab?.engagement?.likes || 0,
      fill: 'rgba(45, 137, 85, 1)',
      // fill: 'rgba(53, 60, 247, 0.5)',
    },
    {
      name: 'Comments',
      value:
        resetFlag === true && filteredData
          ? filteredData?.engagement?.comments
          : overview_tab?.engagement?.comments || 0,
      fill: ' rgba(45, 137, 85, 0.8)',
      // fill: 'rgba(0, 213, 208, 1)',
    },
    {
      name: 'Shares',
      value:
        resetFlag === true && filteredData
          ? filteredData?.engagement?.shares
          : overview_tab?.engagement?.shares || 0,

      fill: ' rgba(45, 137, 85, 0.6)',
    },
  ];

  const engagementYoutubeData = [
    {
      name: 'Likes',
      value:
        resetFlag === true && filteredData
          ? filteredData?.engagement?.likes
          : overview_tab?.engagement?.likes || 0,
      fill: 'rgba(45, 137, 85, 1)',
      // fill: 'rgba(53, 60, 247, 0.5)',
    },
    {
      name: 'Comments',
      value:
        resetFlag === true && filteredData
          ? filteredData?.engagement?.comments
          : overview_tab?.engagement?.comments || 0,
      fill: ' rgba(45, 137, 85, 0.8)',
      // fill: 'rgba(0, 213, 208, 1)',
    },
    {
      name: 'Views',
      value:
        resetFlag === true && filteredData
          ? filteredData?.engagement?.views
          : overview_tab?.engagement?.views || 0,

      fill: ' rgba(45, 137, 85, 0.6)',
    },
  ];
  const totalNoOfPosts =
    resetFlag === true && filteredData
      ? filteredData?.total_count
      : overview_tab?.total_count;
  const [chartType, setChartType] = useState('Volume');

  const renderGenderDemography = {
    'Bar Graph':
      view === 'vertical' ? (
        <VerticalBarGraph
          data={genderDemographicsData}
          type={'%'}
          view={view}
          width='105px'
          showDrillThrough={true}
          job_id={job_id}
          handleTabClick={(data) => handleTabClick(data)}
        />
      ) : (
        <BarGraph
          paddingVal={'20px'}
          data={genderDemographicsData}
          type={'%'}
          isSmall
          borderRadius={'3px 0px 0px 3px'}
          barHeight={'35px'}
          view={view}
          showDrillThrough={true}
          job_id={job_id}
          handleTabClick={(data) => handleTabClick(data)}
        />
      ),
    'Pie Chart': (
      <RatingDonutChart
        data={genderDemographicsData}
        width={450}
        type='percentage'
        showDrillThrough={true}
        job_id={job_id}
        handleTabClick={(data) => handleTabClick(data)}
      />
    ),
    'Donut Chart': (
      <DonutChart
        showDrillThrough={true}
        job_id={job_id}
        handleTabClick={(data) => handleTabClick(data)}
        data={genderDemographicsData}
        type='percentage'
      />
    ),
    'Funnel Chart': (
      <FunnelGraph
        showDrillThrough={true}
        job_id={job_id}
        handleTabClick={(data) => handleTabClick(data)}
        data={genderDemographicsData}
        type={'%'}
      />
    ),
  };
  const renderReactions = {
    'Bar Graph':
      view === 'vertical' ? (
        <VerticalBarGraph
          showDrillThrough={false}
          data={reactionsData}
          view={view}
          showFormatted={true}
          width='105px'
        />
      ) : (
        <BarGraph
          paddingVal={'20px'}
          data={reactionsData}
          isSmall
          showFormatted={true}
          showDrillThrough={false}
          borderRadius={'3px 0px 0px 3px'}
          drillThroughType={'emotion'}
          barHeight={'35px'}
          view={view}
          isFb={true}
          emojiList={{
            like: <img src={LikeIcon} style={{ width: '28px', height: '28px' }} />,
            love: <img src={LoveIcon} style={{ width: '28px', height: '28px' }} />,
            haha: HappyIcon,
            wow: WowIcon,
            care: CareIcon,
            angry: AngryIcon,
            sad: SadIcon,
            length: 3
          }}
        />
      ),
    'Pie Chart': (
      <RatingDonutChart
        showDrillThrough={false}
        data={reactionsData}
        width={450}
        type='percentage'
      />
    ),
    'Donut Chart': (
      <DonutChart
        showDrillThrough={false}
        data={reactionsData}
        type='percentage'
      />
    ),
    'Funnel Chart': (
      <FunnelGraph
        showFormatted={true}
        showDrillThrough={false}
        data={reactionsData}
      />
    ),
  };
  const renderEngagement = {
    'Bar Graph':
      view === 'vertical' ? (
        <VerticalBarGraph
          sorted={channel == 'youtube' ? true : false}
          data={
            channel == 'youtube' ? engagementYoutubeData : engagementGraphData
          }
          showDrillThrough={false}
          // type={'%'}
          view={view}
          showFormatted
          width='105px'
        />
      ) : (
        <BarGraph
          paddingVal={'20px'}
          isSmall
          showFormatted
          sorted={channel == 'youtube' ? true : false}
          data={
            channel == 'youtube' ? engagementYoutubeData : engagementGraphData
          }
          // type={'%'}
          borderRadius={'3px 0px 0px 3px'}
          barHeight={'35px'}
          view={view}
          showDrillThrough={false}
        />
      ),
    'Pie Chart': (
      <RatingDonutChart
        data={
          channel == 'youtube' ? engagementYoutubeData : engagementGraphData
        }
        width={450}
        showDrillThrough={false}
        sorted={channel == 'youtube' ? true : false}

      // type='percentage'
      />
    ),
    'Donut Chart': (
      <DonutChart
        showDrillThrough={false}
        data={
          channel == 'youtube' ? engagementYoutubeData : engagementGraphData
        }
        sorted={channel == 'youtube' ? true : false}
      />
    ),
    'Funnel Chart': (
      <FunnelGraph
        showFormatted
        showDrillThrough={false}
        data={
          channel == 'youtube' ? engagementYoutubeData : engagementGraphData
        }
        sorted={channel == 'youtube' ? true : false}
      />
    ),
  };

  const startDateParsed = useParsedStartDate(
    resetFlag,
    filteredStartDate,
    startDate,
    formatValue
  );
  const endDateParsed = useParsedEndDate(
    resetFlag,
    filteredEndDate,
    endDate,
    formatValue
  );

  const [graphData, setGraphData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [showSidePanel, setShowSidePanel] = useState(false);

  const dispatch = useDispatch();
  const [weekType, setWeekType] = useState(false);
  const [date, setDate] = useState('');
  const handleDataInsightsFetch = (data) => {
    var inputData = convertDateFormat(data?.date);
    var filter_key = [];
    if (data?.likes_count !== undefined) {
      filter_key?.push('likes');
    }
    if (data?.comments_count !== undefined) {
      filter_key.push('comments');
    }
    if (data?.reposts !== undefined) {
      filter_key.push('reposts');
    }
    if (data?.views !== undefined) {
      filter_key.push('views');
    }
    setDate(convertDateFormatString(inputData?.dateString));
    dispatch(
      DetailedInsightsData({
        preview_uuid: preview_uuid,
        job_id: job_id,
        insight_date: inputData?.dateString,
        insight_type: weekType === true ? 'week' : inputData?.type,
        filter_key: filter_key,
      })
    )
      .then((res) => {
        setGraphData(res?.payload?.response);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  return (
    <>
      {resetFlag === true && filteredData === undefined ? (
        <LoaderDiv style={{ marginTop: '-80px' }}>
          <Lottie
            data-testid='loader'
            animationData={Loader}
            loop={true}
            width='100px'
            height='100px'
          />
        </LoaderDiv>
      ) : (
        <Wrapper>
          <SidePanel
            isOpen={showSidePanel}
            setIsOpen={(data) => setShowSidePanel(data)}
            pointGraphData={graphData}
            channel={channel}
            date={date}
            isLoading={graphData === null ? true : false}
            startDate={startDateParsed}
            endDate={endDateParsed}
            chartType={chartType}
            search_type={search_type}
          />
          <Container>
            <ChildContainer justify='flex-start'>
              <OverallReview
                backgroundColor='rgba(45, 137, 85, 1)'
                // backgroundColor='rgba(0, 213, 208, 0.5)'
                icon={channel == 'facebook' ? FacebookLogo : YouTubeRedIcon}
                message={
                  startDateParsed?.length < 1 ||
                    startDateParsed === undefined ||
                    startDateParsed === null
                    ? `${totalNoOfPosts} Relevant posts were observed for this evaluation`
                    : `${totalNoOfPosts} Relevant posts were observed From ${startDateParsed} to ${endDateParsed}`
                }
                inforText={
                  channel === 'facebook' ?
                    'The total number of posts relevant to your query within the specified time period.'
                    :
                    'The total number of YouTube videos and shorts relevant to your query'
                }
              />
            </ChildContainer>

            <ChildContainer>
              <GraphHOC
                graphWidth={'100%'}
                margin={'20px 0px 20px 0px'}
                title={'Engagement'}
                options={options}
                renderScreen={renderEngagement}
                startDate={startDateParsed}
                endDate={endDateParsed}
                option={filterOption}
                hideDropdown={hideDropdown}
                formatValue={formatValue}
                infoText={
                  channel == 'facebook' ?
                    'The total number of likes and comments on posts relevant to your query within the specified time period.'
                    :
                    'Overview of engagement metrics across YouTube videos and shorts'
                }
              />
            </ChildContainer>
            {/* )} */}
          </Container>
          {channel == 'youtube' ? (
            <></>
          ) : (
            <ChildContainer>
              <GraphHOC
                title={'Top  Reactions'}
                options={options}
                graphWidth={'100%'}
                margin={'20px 0px 20px 0px'}
                renderScreen={renderReactions}
                startDate={startDateParsed}
                endDate={endDateParsed}
                option={filterOption}
                hideDropdown={hideDropdown}
                formatValue={formatValue}
                infoText={
                  'View the top reactions on posts, including like, love, and other user responses, to analyze user engagement and interaction trends.'
                }
              />
            </ChildContainer>
          )}
          <ChildContainer>
            <GraphHOC
              title={'Gender Demographics'}
              options={options}
              graphWidth={'100%'}
              margin={'20px 0px 20px 0px'}
              renderScreen={renderGenderDemography}
              startDate={startDateParsed}
              endDate={endDateParsed}
              option={filterOption}
              hideDropdown={hideDropdown}
              formatValue={formatValue}
              infoText={
                channel == 'facebook' ?
                  'The percentage gender distribution of user accounts relevant to your query, with categories for Male, Female, and Unknown when gender data is unavailable.'
                  :
                  'Gender distribution of engaged viewer accounts, with ‘unknown’ where data isn’t available.'
              }
            />
          </ChildContainer>
          {/* <ChildContainer>
            <TrendsInUserActivity
              data1={{
                trends_in_user_activity:
                  resetFlag === true && filteredData
                    ? filteredData?.volume
                    : overview_tab?.volume,
              }}
              title={`Volume`}
              ylabel={'Volume'}
              // countName = {'engagement_count'}
              // option='Weeks'
              hideDropdown={hideDropdown}
              startDate={startDateParsed}
              endDate={endDateParsed}
              formatValue={formatValue}
              infoText={
                'Track the total number of posts over a specified time period.'
              }
            />
          </ChildContainer> */}

          <ChildContainer data-testid='trends-in-user-activity'>
            <TrendsInUserActivity
              data1={
                chartType !== 'Engagements'
                  ? {
                    trends_in_user_activity:
                      resetFlag === true && filteredData
                        ? filteredData?.volume
                        : overview_tab?.volume,
                  }
                  : {
                    trends_in_user_activity:
                      resetFlag === true && filteredData
                        ? filteredData?.trends_in_user_activity
                        : overview_tab?.trends_in_user_activity,
                  }
              }
              ylabel={chartType === 'Engagements' ? 'Engagement' : 'Volume'}
              title={
                chartType === 'Engagements'
                  ? 'Trends in User Activity'
                  : 'Volume'
              }
              // countName = {'engagement_count'}
              // option='Weeks'
              hideDropdown={hideDropdown}
              startDate={startDateParsed}
              endDate={endDateParsed}
              showFilters={true}
              channel={channel}
              onEmitTimeSpanClick={setWeekType}
              setChartType={(data) => setChartType(data)}
              dataPointClickEnabled={true}
              handleDataPoint={(data) => {
                setIsLoading(true);
                setGraphData(null);
                handleDataInsightsFetch(data?.payload);
                setIsLoading(false);
                setShowSidePanel(true);
              }}
              formatValue={formatValue}
              infoText={
                chartType === 'Engagements' ?
                  channel == 'facebook' ?
                    'Track the total engagement on posts, combining likes, comments, reposts, and views, over a specified time period.'
                    :
                    'Track time-based engagement trends across YouTube videos and Shorts'
                  : 'Track the total number of posts over a specified time period.'
              }
              typeVal={channel == 'youtube' ? 'youtube' : 'instagram'}
            />
          </ChildContainer>
          <DynamicCorrelationGraph
            correlationAnalysisData={overview_tab?.heat_map?.engagement_count}
            startDate={startDateParsed}
            endDate={endDateParsed}
            likesData={overview_tab?.heat_map?.likes_count}
            repliesData={overview_tab?.heat_map?.reply_count}
            retweetData={overview_tab?.heat_map?.retweet_count}
            viewData={overview_tab?.heat_map?.view_count}
            commentsData={overview_tab?.heat_map?.comments_count}
            sharesData={overview_tab?.heat_map?.shares_count}
            viewsData={overview_tab?.heat_map?.view_count}
            data-testid='dynamic-correlation-graph'
            infoText={channel == 'facebook' ? 'Heatmap tracking user engagement over time, showing the type and frequency of interactions during each period.' : 'Heatmap of viewer engagement intensity over time.'}
          ></DynamicCorrelationGraph>
        </Wrapper>
      )}
    </>
  );
};

export default OverviewTabFb;
